import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from '../Loader'; // Assuming you have this component
import { Box, Typography } from '@mui/material';

const LogoutPage = () => {
  const { logout, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        toast.success('You have been successfully logged out');
        // Redirect to login after a brief delay
        setTimeout(() => navigate('/', { replace: true }), 1500);
      } catch (error) {
        toast.error('Logout failed. Please try again.');
        navigate(-1); // Go back to previous page if logout fails
      }
    };

    performLogout();
  }, [logout, navigate]);

  if (isLoading) {
    return <LoadingSpinner/>;
  }

  return (
    <Box>
      <ToastContainer />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#f0f0f0',
        }}
      >
        <Typography variant="h4" sx={{ marginBottom: 2 }}>
          Logging Out...
        </Typography>
        <LoadingSpinner fullPage={true} />
      </Box>
    </Box>
  );
};

export default LogoutPage;